// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__AuCnd","username":"Avatar_username__pa_Lm"};